<div class="pep-declaration-step">
  <p class="main-question">
    <strong>Datos de la persona con cargo politico</strong>
  </p>
  <p class="subtext">
    Completa los datos de la persona (tu o tu familiar) que tiene o tuvo el cargo politico.
  </p>

  <form [formGroup]="pepForm" (ngSubmit)="onSubmit()" class="form-wrapper">

    <!-- Parentesco primero para contexto -->
    <div class="field-group">
      <label class="field-label">¿Cual es tu relacion con esta persona?</label>
      <select formControlName="parentesco">
        <option value="" disabled selected>Selecciona una opcion</option>
        <option *ngFor="let p of parentescoOptions" [value]="p.value">
          {{ p.label }}
        </option>
      </select>
    </div>

    <!-- Campo "otro" parentesco -->
    <input
      *ngIf="showOtherParentesco"
      type="text"
      formControlName="otroParentesco"
      placeholder="Especifica la relacion"
      autocomplete="off"
    />

    <!-- Separador visual -->
    <div class="section-divider">
      <span>Datos de la persona</span>
    </div>

    <!-- Nombres -->
    <input
      type="text"
      formControlName="nombre"
      placeholder="Nombre(s)"
      autocomplete="off"
    />

    <!-- Apellidos en una fila -->
    <div class="row-two">
      <input
        type="text"
        formControlName="apellidoPaterno"
        placeholder="Apellido paterno"
        autocomplete="off"
      />
      <input
        type="text"
        formControlName="apellidoMaterno"
        placeholder="Apellido materno"
        autocomplete="off"
      />
    </div>

    <!-- Documento -->
    <input
      type="text"
      formControlName="documentNumber"
      placeholder="RUT o numero de documento"
      autocomplete="off"
    />

    <!-- Nacionalidad -->
    <div class="select-with-flag">
      <img
        *ngIf="pepForm.get('nacionalidad')?.value"
        [src]="'assets/flags/' + getFlagForCountry(pepForm.get('nacionalidad')?.value)"
        alt="Bandera"
        class="flag-preview"
      />
      <select formControlName="nacionalidad" [class.has-value]="pepForm.get('nacionalidad')?.value">
        <option value="" disabled selected>Nacionalidad</option>
        <option *ngFor="let country of countries" [value]="country.name">
          {{ country.name }}
        </option>
      </select>
    </div>

    <!-- Separador visual -->
    <div class="section-divider">
      <span>Cargo politico</span>
    </div>

    <!-- Cargo ocupado -->
    <div class="field-group">
      <label class="field-label">¿Que cargo tiene o tuvo?</label>
      <select formControlName="cargoOcupado">
        <option value="" disabled selected>Selecciona el cargo</option>
        <option *ngFor="let cargo of cargosOptions" [value]="cargo">
          {{ cargo }}
        </option>
      </select>
    </div>

    <!-- Checkbox de confirmacion -->
    <label class="checkbox-label">
      <input type="checkbox" formControlName="confirmDeclaration" />
      <span>
        Confirmo que esta informacion es verdadera y autorizo su verificacion.
      </span>
    </label>

    <!-- Acciones -->
    <button
      type="submit"
      [disabled]="pepForm.invalid || loading"
    >
      {{ loading ? 'Guardando...' : 'Finalizar declaracion' }}
    </button>
    <button
      type="button"
      class="back-btn"
      (click)="goBack()"
      [disabled]="loading"
    >
      Volver
    </button>
  </form>
</div>
